/* eslint-disable max-len */
export default function AddAgendaItemNoteDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  oversightDataService,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveAgendaItemComment = _handleSaveAgendaItemComment;

  vm.IsValidControl = _IsValidControl;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.oversight.addAgendaItemCommentDialog);
    if (vm.saved === true) {
      vm.saved = false;
      if (vm.refreshAgendaItem === true) {
        $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
      } else {
        // $rootScope.$broadcast('refreshAgendaItemComments', { agendaItemId: vm.agendaItemId });
        $rootScope.$broadcast('refreshAgendaItemEdit', { agendaItemId: vm.agendaItemId });
      }
    }
  }

  function _handleSaveAgendaItemComment() {
    const dfdSave = $q.defer();
    loaderService.showViewLoader = true;
    if ($scope.addAgendaItemNoteForm.$valid) {
      if (vm.type === 'note') {
        oversightDataService.saveAgendaItemComments(vm.agendaItemId, vm.agendaItemCommentId, vm.agendaItemCommentText).then((response) => {
          if (!response.data) {
            alerts.error('Error occurred while saving the Agenda Item Note.');
          } else {
            alerts.success('The Agenda Item Note has been saved successfully.');
            vm.saved = true;
          }
          loaderService.showViewLoader = false;
          dfdSave.resolve();
        });
      } else {
        oversightDataService.saveAgendaItemFollowup(vm.agendaItemId, vm.agendaItemFollowupId, vm.agendaItemFollowupText).then((response) => {
          if (!response.data) {
            alerts.error('Error occurred while saving the Agenda Item Note Followup.');
          } else {
            alerts.success('The Followup Note has been saved successfully.');
            vm.saved = true;
          }
          loaderService.showViewLoader = false;
          dfdSave.resolve();
        });
      }
    } else {
      dfdSave.reject();
    }
  }

  function _IsValidControl(ctrl) {
    return ($scope.addAgendaItemNoteForm)
      && (($scope.addAgendaItemNoteForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }
}

AddAgendaItemNoteDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'oversightDataService'
];
